import * as React from 'react';
import {styled} from '../../utils';
import {FormFieldProps} from './types';

const Root = styled('label')({
  display: 'block',
  marginBottom: 40,
  textAlign: 'left'
});

const LabelText = styled('span')(({theme}) => ({
  color: '#575C64',
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.base,
  textTransform: 'uppercase',
  display: 'inline-block',
  marginBottom: 10
}));

export default class FormField extends React.Component<FormFieldProps, {}> {
  public render() {
    const {children, label, ...restProps} = this.props;

    return (
      <Root {...restProps}>
        {label ? <LabelText>{label}</LabelText> : null}
        {children}
      </Root>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormField/FormField.tsx